<div ng-controller="viewDefinitionsController as ctrl" class="modal-view view-definitions">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    <c-flexible-list-item-editor configuration="ctrl.visualEditorConfig"></c-flexible-list-item-editor>
    <div class="flex-example-list-container">
        <div class="flex-example"></div>
    </div>
    <div class="list-container">
        <ul class="definition-list">
            <li class="header">
                <span>View Definition</span><span class="type">Default For</span><span class="routes">For Route(s)</span><span class="name">Named</span><span class="wfconfigs">Cfg(s)</span><span class="delete"></span>
            </li>
            <li ng-repeat="item in ctrl.items track by $index">
                <span class="link" ng-click="ctrl.edit(item)" ng-class="{ inactive: !item.active }">{{item.title}}</span>
                <span class="type">{{item.type}}</span>
                <span class="routes">{{item.route}}</span>
                <span class="name">{{item.viewName}}</span>
                <span class="wfconfigs">{{item.connectedConfigs}}</span>
                <span class="delete"><i ng-if="item.canDelete" ng-click="ctrl.delete(item)" class="fa fa-times"></i></span>
            </li>
        </ul>
    </div>
</div>